import { render } from "./index.vue?vue&type=template&id=c6fe8d40&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=c6fe8d40&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c6fe8d40"

export default script